import { z } from 'zod';

export const anonRunConfigSchema = z.object({
  macroOffsets: z.object({ // ROIOffset max + 1 mm of safety
    left: z.number().nonnegative().max(37 + 1).prefault(0),
  }).describe('Parts of the macro to hide. Only left, as it is the only dimension that matter for now'),
}).describe('Configuration used for each anonymization run');

export type AnonRunConfig = z.infer<typeof anonRunConfigSchema>;
